import React from 'react';
import {
  AgricultureOutlined,
  ApartmentOutlined,
  AssignmentOutlined,
  BedOutlined,
  BusinessCenterOutlined,
  BusinessOutlined,
  DescriptionOutlined,
  DriveEtaOutlined,
  FilterOutlined,
  GrassOutlined,
  GroupOutlined,
  HandymanOutlined,
  HandshakeOutlined,
  HolidayVillageOutlined,
  Language,
  LocationOnOutlined,
  MeetingRoomOutlined,
  RequestQuoteOutlined,
  VillaOutlined,
  WavesOutlined,
  VpnKey,
} from '@mui/icons-material';

/**
 * Maps group names to their corresponding MUI Icon components.
 * Using a map outside the component body makes the switch logic unnecessary,
 * improves readability, and centralizes the configuration.
 */
const iconMap: { [key: string]: React.ElementType } = {
  'Listing Details': DescriptionOutlined,
  'Transaction Participants': GroupOutlined,
  'Listing Agreement': HandshakeOutlined,
  'Media Center': FilterOutlined,
  Location: LocationOnOutlined,
  'Association/Community': HolidayVillageOutlined,
  Taxes: RequestQuoteOutlined,
  'Building and Utilities': HandymanOutlined,
  'Features and Rooms': BedOutlined,
  'Lot and Parking': DriveEtaOutlined,
  'Water/Shore': WavesOutlined,
  'Remarks and Internet Settings': Language,
  Showing: VpnKey,
  'Commercial Sale Details': BusinessOutlined,
  'Multi-Family Details': VillaOutlined,
  'Open Houses': MeetingRoomOutlined,
  'Commercial Lease Details': ApartmentOutlined,
  'Business Opportunity': BusinessCenterOutlined,
  'Farm Details': AgricultureOutlined,
  'Land Details': GrassOutlined,
  'Lease Details': AssignmentOutlined,
};

interface EditNavigationIconsProps {
  groupName: string;
}

/**
 * Renders the appropriate MUI Icon based on the provided groupName.
 * It defaults to DescriptionOutlined if the groupName is not found.
 *
 * @param {string} groupName - The name of the navigation group.
 * @returns {JSX.Element} The corresponding MUI Icon component.
 */
export const EditNavigationIcons = React.memo(
  ({ groupName }: EditNavigationIconsProps) => {
    // Get the Icon component from the map.
    // If not found, default to DescriptionOutlined.
    const IconComponent = iconMap[groupName] || DescriptionOutlined;

    // Render the selected Icon component.
    // The component is returned as an element.
    return <IconComponent />;
  },
);
